export const actions = {
    UPDATE_USER_INFO: "update-user-info",
    UPDATE_APPLICANT_INFO: "update-applicant-info",
    UPDATE_LOADING: "update-loading",
    LOGIN: "login",
    LOGOUT: "logout",
    SHOW_ERROR: "show-error",
    UPDATE_SELLING_FORM_OBJECT: "update-selling-form-object",
    UPDATE_ACCESS_TOKEN: "update-access-token",
    START_NEW_SELLING_PROCESS: "start-new-selling-process",
    SHOW_SUCCESS: "showSuccess",
    UPDATE_SELLING_TASK_ID: "update-selling-task-id",
    NO_ERROR: "setNoError",
    START_NEW_MORTGAGE_PROCESS: "startNewMortgageProcess"
}
export const setAuthInformation = (payload) => {
    return { type: actions.UPDATE_USER_INFO, payload }
}

export const updateApplicantInfo = (payload) => {
    return { type: actions.UPDATE_APPLICANT_INFO, payload }
}

export const logout = (payload) => {
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")

    return { type: actions.LOGOUT, payload }
}
export const updateLoading = (payload) => {
    return { type: actions.UPDATE_LOADING, payload };
}

let errorTimeoutId = null;

export const showError = (payload, timeout = 15000) => (dispatch) => {
    if (errorTimeoutId) {
        clearTimeout(errorTimeoutId);
    }

    dispatch({ type: actions.SHOW_ERROR, payload });

    if (payload) {
        errorTimeoutId = setTimeout(() => {
            dispatch({ type: actions.SHOW_ERROR, payload: "" });
        }, timeout);
    }
}

export const updateSellingFormObject = (payload) => {
    return { type: actions.UPDATE_SELLING_FORM_OBJECT, payload };
}

export const updateAccessToken = (payload) => {
    return { type: actions.UPDATE_ACCESS_TOKEN, payload };
}

export const startNewSellingProcess = () => {
    return { type: actions.START_NEW_SELLING_PROCESS };
}

export const startNewMortgageProcess = () => {
    return { type: actions.START_NEW_MORTGAGE_PROCESS };
}

export const showSuccess = (payload, summaryMessage = "") => {
    return { type: actions.SHOW_SUCCESS, payload, summaryMessage };
}

export const logUserIn = () => {
    return { type: actions.LOGIN }
}

export const setNoError = (payload) => {
    return { type: actions.NO_ERROR, payload }
}
